import { createSlice } from "@reduxjs/toolkit";

const ResponsePendingReducerSlice = createSlice({
  name: "ResponsePendingReducer",
  initialState: {
    assignGroupOnRecalculate: false,
    assignGroupOnSubmit: false,
    closeFeedbackOnRecalculate: false,
    acceptFeedbackOnSubmit: false,
    addFeedbackOnSubmit: false,
    closeFeedbackOnSubmit: false,
    discardFeedbackOnSubmit: false,
    searchFeedbackOnSubmit: false,
    escalationMatrixOnSubmit:false
  },
  reducers: {
    setResponsePendingReducer: (state, action) => {
      state.assignGroupOnSubmit = action.payload.assignGroupOnSubmit || false;
      state.acceptFeedbackOnSubmit =
        action.payload.acceptFeedbackOnSubmit || false;
      state.addFeedbackOnSubmit = action.payload.addFeedbackOnSubmit || false;
      state.closeFeedbackOnSubmit =
        action.payload.closeFeedbackOnSubmit || false;
      state.discardFeedbackOnSubmit =
        action.payload.discardFeedbackOnSubmit || false;
      state.assignGroupOnRecalculate =
        action.payload.assignGroupOnRecalculate || false;
      state.closeFeedbackOnRecalculate = action.payload.closeFeedbackOnRecalculate || false;
      state.searchFeedbackOnSubmit = action.payload.searchFeedbackOnSubmit || false;
      state.escalationMatrixOnSubmit= action.payload.escalationMatrixOnSubmit || false;
    },
  },
});

export const { setResponsePendingReducer } =
  ResponsePendingReducerSlice.actions;
export default ResponsePendingReducerSlice.reducer;
